module.exports = __webpack_public_path__ + "static/staff_of_the_python-47920748cb0769c86d701e4d7234fd16.jpeg";